<script>
import { galleryLeftButton, galleryRightButton } from "@project/theme-buttons.vue";

export const gallery4Theme = {
  rightButton: galleryRightButton,
  leftButton: galleryLeftButton,
  outerContainerStyle: "height:80vh",
  coverLayerStyle: "background-color:rgba(0,0,0,0)",
  tabGroup: {
    outerContainerStyle: "left:50%; top:auto; bottom:5px; transform:translateX(-50%);",
    outerContainerClasses: { override: "sb-abox hta-header-gallery-tablist" },
  },
};

export const homePageHeaderGallery4 = {
  rightButton: galleryRightButton,
  leftButton: galleryLeftButton,
  outerContainerStyle: "height:calc(100vh - 150px)",
  coverLayerStyle: "background-color:rgba(0,0,0,0.3)",
  tabGroup: {
    outerContainerStyle: "left:50%; top:auto; bottom:5px; transform:translateX(-50%);",
    outerContainerClasses: { override: "sb-abox hta-header-gallery-tablist" },
  },
};

export default { name: "theme-gallery4" };
</script>

<style>
.hta-header-gallery-tablist {
  box-sizing: border-box;
  border: 0 transparent solid;
  display: inline-block;
  height: 30px;
}
</style>
